<template>
  <el-row :gutter="10">
    <el-col :xs="24"
            :span="5">
      <el-card shadow="none">
        <div slot="header"><i class="el-icon-discount mr-10"></i>楼宇</div>
        <el-tree highlight-current
                 default-expand-all
                 class="room-tree"
                 ref="roomTree"
                 node-key="id"
                 :expand-on-click-node="false"
                 :current-node-key="currentKey"
                 :data="treeData"
                 :props="defaultProps"
                 @node-click="handleNodeClick">
        </el-tree>
      </el-card>
    </el-col>
    <el-col :xs="24"
            :span="19">
      <el-card shadow="none"
               class="form-card mb-15">
        <el-form :inline="true"
                 :model="searchForm"
                 ref="search_form"
                 class="search-form">
          <el-form-item label="房间名称:"
                        prop="name">
            <el-input v-model.trim="searchForm.name"
                      placeholder="房间名称"></el-input>
          </el-form-item>
          <el-form-item label="房间类型:"
                        prop="room_type_id">
            <el-select v-model="searchForm.room_type_id"
                       placeholder="房间类型">
              <el-option v-for="(item, index) in roomList"
                         :key="index"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       @click="searchSubmit('search_form')">查询
            </el-button>
            <el-button icon="el-icon-refresh"
                       @click="resetForm('search_form')">重置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-row>
        <el-button v-has="'/room/add'"
                   type="primary"
                   @click="handleAdd">新增</el-button>
        <el-button v-has="'/room/batch_del'"
                   type="primary"
                   @click="multipleDelete">批量删除</el-button>
        <el-upload class="c-import-btn"
                   :show-file-list="false"
                   :headers="{ token: authId }"
                   ref="upload"
                   :action="url"
                   accept=".xlsx,.xls"
                   :on-success="handleUploadSuccess">
          <el-button v-has="'/room/import'"
                     slot="trigger"
                     type="primary">导入</el-button>
        </el-upload>
        <el-button v-has="'/room/export'"
                   type="primary"
                   @click="handleExport">导 出</el-button>
      </el-row>
      <el-card shadow="none"
               class="mt-15">
        <el-table max-height="575"
                  ref="multipleTable"
                  :data="tableData"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="80"> </el-table-column>
          <el-table-column v-for="(item, index) in tableTitle"
                           :fixed="item.fixed"
                           :key="index"
                           :label="item.name"
                           :prop="item.prop"
                           :min-width="item.width"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="150">
            <template slot-scope="scope">
              <el-button v-has="'/room/edit'"
                         size="mini"
                         type="primary"
                         @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-has="'/room/batch_del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="pagination.total"
                    :pageSize="pagination.perPage"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrent="handleCurrentChange"></Pagination>
      </el-card>
    </el-col>
    <add-room v-if="showRoomModal"
              :isShow="showRoomModal"
              :data="roomData"
              @handleClose="closeRoomModal"></add-room>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import utils from '@/common/utils'
import AddRoom from '@/views/basic/room/AddRoom'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddRoom, Pagination },
  data() {
    return {
      url: fetch.importRoom,
      authId: localStorage.getItem('token'),
      currentKey: '',
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      treeData: [],
      searchForm: {
        name: '',
        room_type_id: ''
      },
      roomList: [],
      tableTitle: [
        {
          prop: 'house_id',
          name: '房屋ID',
          width: '180'
        },
        {
          prop: 'community',
          name: '小区',
          width: '160'
        },
        {
          prop: 'building',
          name: '楼号',
          width: '100'
        },
        {
          prop: 'unit',
          name: '单元',
          width: '100'
        },
        {
          prop: 'name',
          name: '房间名称',
          width: '120'
        },
        {
          prop: 'room_type_name',
          name: '房间类型',
          width: '100'
        },
        {
          prop: 'area_names',
          name: '所属区域',
          width: '200'
        },

        {
          prop: 'remarks',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加假日相关
      showRoomModal: false,
      roomData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getRoomTypeList()
    this.getAreaTree().then(() => {
      this.getList()
    })
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      return Promise.resolve(
        fetch
          .getRoomList({
            area_id: this.currentKey,
            perPage: perPage,
            currentPage: currentPage,
            ...this.searchForm
          })
          .then((data) => {
            data.procData(
              data.res,
              (data) => {
                this.pagination.total = Number(data.total)
                this.tableData = data.list
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
      )
    },
    // 获取房型
    getRoomTypeList() {
      fetch.getRoomTypeList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取树结构数据
    getAreaTree() {
      return Promise.resolve(
        fetch.getAreaTree({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.treeData = data.treeData
              this.currentKey = data.treeData[0].id
              this.$nextTick(function () {
                this.$refs.roomTree.setCurrentKey(data.treeData[0].id)
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    // 树形菜单单击
    handleNodeClick(data) {
      this.currentKey = data.id
      if (data.area_type === 'area_type_yes') {
        this.getList()
      } else {
        this.$message.info('该机构下暂无房间')
      }
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加假日管理
    handleAdd() {
      this.showRoomModal = true
      this.roomData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delRoom(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择房间后重试')
      }
    },
    // 导入
    handleUploadSuccess(res) {
      if (200 === Number(res.code)) {
        this.$message.success('导入成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    // 导出
    handleExport() {
      fetch
        .exportRoom(
          {
            ...this.searchForm
          },
          { responseType: 'blob' }
        )
        .then((data) => {
          var blob = new Blob([data.res])
          let date = utils.format(new Date().getTime(), 'yyyy-MM-dd')
          let filename = '房间列表-' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        })
    },
    // 编辑
    handleEdit(data) {
      this.showRoomModal = true
      this.roomData = {
        type: 'edit',
        id: data.id
      }
    },
    closeRoomModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showRoomModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRoom(data.id)
        })
        .catch(() => {})
    },
    // 删除房间
    delRoom(ids) {
      fetch.batchDelRoom({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.room-tree.el-tree {
  .el-tree-node__content {
    height: 30px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
